import { render, staticRenderFns } from "./Registres.vue?vue&type=template&id=05de6a4a&scoped=true"
import script from "./Registres.vue?vue&type=script&lang=ts"
export * from "./Registres.vue?vue&type=script&lang=ts"
import style0 from "./Registres.vue?vue&type=style&index=0&id=05de6a4a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de6a4a",
  null
  
)

export default component.exports